import { TextField } from '@mui/material';
import { LocalizationProvider, DatePicker as MUIDatePicker } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { FieldConfig, Field as FormikField, FieldProps as FormikFieldProps } from 'formik';
import React, { useEffect } from 'react';
import { TypographyProps } from '../../../../state/ducks/common/types';
import { useFormContext } from '../FormContext';
import Field, { FieldOwnProps } from './Field';

type DatePickerPropsWithFormik = FieldOwnProps &
FormikFieldProps &
Partial<TypographyProps>;

const DatePicker: React.FunctionComponent<DatePickerPropsWithFormik> = ({
  label,
  minDate,
  value,
  ...fieldProps
}) => {
  const { submitForm } = useFormContext();

  useEffect(() => {
    if (value) {
      handleDateChange(value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDateChange = (date) => {
    const { form } = fieldProps;
    form.setFieldValue(fieldProps.field.name, date);
    submitForm();
  };

  return (
    <Field label={label} {...fieldProps}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <MUIDatePicker
          inputFormat="MM/DD/YYYY"
          value={fieldProps.field.value}
          onChange={handleDateChange}
          minDate={minDate}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              fullWidth
              variant="outlined"
              disabled
              error={Boolean(fieldProps.form.errors[fieldProps.field.name])}
              helperText={fieldProps.form.errors[fieldProps.field.name] as string}
            />
          )}
        />
      </LocalizationProvider>
    </Field>
  );
};

type DatePickerFieldProps = FieldOwnProps &
FieldConfig &
Partial<TypographyProps>;

const DatePickerField: React.FunctionComponent<DatePickerFieldProps> = (props) => (
  <FormikField component={DatePicker} {...props} />
);

export default DatePickerField;
